import GlitchMob from '../Mobs/GlitchMob'
import HunterMob from '../Mobs/HunterMob'

export default class {
    constructor (game) {
        this.game = game
        this._player = game.getPlayer()

        this._engageInterval = 20
        this._startEngageLoop()

        this._mobs = [
            {
                chance: 0.1,
                groupSize: 10,
                currentPopulation: 0,
                maxPopulation: 2,
                Class: GlitchMob,
            }, {
                chance: 0.01,
                currentPopulation: 0,
                maxPopulation: 20,
                groupSize: 1,
                Class: HunterMob,
            },
        ]
        /// TODO: starting mobs
        /// TODO: huntermob
        /// TODO: hide ui on mobile
        /// TODO: dead mob cleanup
        /// TODO: gameover message
    }

    _startEngageLoop () {
        this.game.setTickTimeout(() => {
            this._engage()
        }, this._engageInterval)
    }

    _engage () {
        let roll = Math.random()
        this._mobs.forEach(mob => {
            console.log(mob.currentPopulation)
            if (mob.currentPopulation < mob.maxPopulation && roll < mob.chance) {
                let groupSize = Math.ceil(Math.random() * mob.groupSize)
                for (let i = 0; i < groupSize; i++) {
                    mob.currentPopulation++

                    let instance = new mob.Class(this.game.getScene().getRandomBorderPosition())
                    this.game.getWorld().add(instance)
                    instance.onDeath(() => mob.currentPopulation--)
                }
            }
        })

        this._startEngageLoop()
    }
}
